import { render, staticRenderFns } from "./ViewMarketplaceVehicles.vue?vue&type=template&id=3a2970f4"
import script from "./ViewMarketplaceVehicles.vue?vue&type=script&lang=js"
export * from "./ViewMarketplaceVehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports